// extracted by mini-css-extract-plugin
export default {"scope":"BGiWS","header--is-user-invalid":"_3K5AO","icon":"nblJb","purpose":"FwUI4","field":"lne-0","button":"AmABx"};